import { render } from "./Pro.vue?vue&type=template&id=5281a804&scoped=true"
import script from "./Pro.vue?vue&type=script&lang=js"
export * from "./Pro.vue?vue&type=script&lang=js"

import "./Pro.vue?vue&type=style&index=0&id=5281a804&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5281a804"]])

export default __exports__